export { default as default } from './KitMenu';
